import angular from 'angular';

import dropdown from 'ui-bootstrap4/src/dropdown';
import progressbar from 'ui-bootstrap4/src/progressbar';

import { ExecutiveReportsDashboardComponent } from './executive-reports-dashboard.component';
import { ReportDetailsModalComponent } from './report-details-modal.component';
import { ReportHistoryComponent } from './report-history.component';
import { ReportJobParametersComponent } from './report-job-parameters.component';
import { ReportProgressComponent } from './report-progress.component';
import { RequestReportComponent } from './request-report.component';
import { ReportJobsRoutingModule } from './report-jobs-routing.module';

export const ReportJobsModule = angular
    .module("apex.mainApp.reportJobs", [
        dropdown,
        progressbar,
        ReportJobsRoutingModule
    ])
    .component("apexExecutiveReportsDashboard", ExecutiveReportsDashboardComponent)
    .component("apexReportDetailsModal", ReportDetailsModalComponent)
    .component("apexReportHistory", ReportHistoryComponent)
    .component("apexReportJobParameters", ReportJobParametersComponent)
    .component("apexReportProgress", ReportProgressComponent)
    .component("apexRequestReport", RequestReportComponent)
    .name;
